<template>
  <a-config-provider :locale="locale">
    <router-view v-if="isRouterActive" />
  </a-config-provider>
</template>
<script>
import { ref, provide, nextTick, onMounted } from "vue";
import { useStore } from "vuex";
import { requestArea } from "@/utils/init-area";
import { getRsaKey, updateStudentInfo } from "@/utils/function.js";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");
export default {
  name: "App",
  setup() {
    const isRouterActive = ref(true);
    const store = useStore();
    provide("reload", () => {
      isRouterActive.value = false;
      nextTick(() => {
        isRouterActive.value = true;
      });
    });

    onMounted(() => {
      getArea();
      getRsaKey();

      // let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      // store.commit('data/SET_USER_INFO2', userInfo) 
      // if (userInfo) {
      //   updateStudentInfo().then((res) => { 
      //     store.commit('data/SET_USER_INFO2', res) 
      //     // console.log("getUserInfo1===", store.getters["data/getUserInfo2"]);
      //   }).catch((err) => { 
      //     console.log("err===", err);
      //   }); 
      // } 
    }); 

    // 获取省市区数据
    const getArea = async () => {
      const data = await requestArea();
      store.commit(`cachedView/SET_AREA`, data);
    };
    return {
      isRouterActive,
      locale: zhCN,
    };
  },
};
</script>

<style>
div,
span {
  font-family: "黑体";
}
.dis_ajc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-content img {
  width: 100%;
}

</style>

<style lang="scss">
@import "@/style/var.scss";

//修改滚动条宽度或高度
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar:horizontal {
  height: 8px;
}
// 修改滑块的颜色和样式
::-webkit-scrollbar-thumb:horizontal,
::-webkit-scrollbar-thumb:vertical {
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);
  background: #CFCFCF;
}
// 修改滚动条轨道的样式 
::-webkit-scrollbar-track:horizontal ,
::-webkit-scrollbar-track:vertical {
  background: #DFDFDF;
}


</style>
